export default "__VITE_ASSET__30b43f73__"